import { useMutation as useTanstackMutation } from '@tanstack/react-query';

// import { queryClient } from '.';


function useBaseMutation(client, params) {
  const { mutateFn, ...restParams } = params;

  const mutateFnDefault = (variables) => {
    return mutateFn({ ...variables, apiClient: client});
    // TODO: are we really need to pass query client here?
    //       Consider passing it to onSuccess for client data update
    // return mutateFn({ ...variables, apiClient: client, queryClient });
  };

  // TODO: Think about mutation key
  const mutation = useTanstackMutation({
    mutationFn: mutateFnDefault,
    ...restParams,
  });

  return mutation;
}

export default useBaseMutation;
